/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanVersion: core.serialization.ObjectSchema<
    serializers.LessThanVersion.Raw,
    Truvity.LessThanVersion
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanVersion {
    export interface Raw {
        value: number;
    }
}
